var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0769 14H19.6953V14.1671V17.5678H27.0769V14Z",
    fill: "#7BC658"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8051 15.0586H15.9082V17.5679H18.8051V15.0586Z",
    fill: "#7BC658"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0328 33.9993C26.6097 33.9993 27.0774 33.5316 27.0774 32.9547C27.0774 32.3778 26.6097 31.9102 26.0328 31.9102C25.4559 31.9102 24.9883 32.3778 24.9883 32.9547C24.9883 33.5316 25.4559 33.9993 26.0328 33.9993Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7594 33.9993C18.3363 33.9993 18.804 33.5316 18.804 32.9547C18.804 32.3778 18.3363 31.9102 17.7594 31.9102C17.1825 31.9102 16.7148 32.3778 16.7148 32.9547C16.7148 33.5316 17.1825 33.9993 17.7594 33.9993Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1001 20.9581H18.8049H19.6963H25.4442L25.0595 22.1395H17.5861L17.1001 20.9581Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.1c394604626c2d51a51fbf06d225e215.svg";
export { ForwardRef as ReactComponent };